
const baseURL = "https://reslinkbe.net";



export default baseURL;
